import HttpStatus from 'http-status-codes';
import _ from 'lodash';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import moment from 'moment';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { withTranslation } from 'react-i18next';
import { IndexLink, Link } from 'react-router';
import { asyncRequest, Entities, fetchAllCustomRepository, getEntities, TOMCAT_URL, UserRole } from 'src/common/index';
import Logout from 'src/components/account/logout';
import { TripBookingFilter } from 'src/components/trips/bookings/booking-administration-filter';
import composeModalActions from 'src/utils/modal-action-wrapper';
import logo from 'static/Busfinder_Pin_240.png';
import { VisibilityStatus } from '../company/VisibilityStatus';
import { IconLabel } from 'src/components/administration/IconLabel';
import { connect } from 'react-redux';
import OperatorNotificationsBadge from 'src/components/nav/components/operator-notifications-badge';
import CircularProgress from 'material-ui/CircularProgress';

class Header extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.didNewTasksFetch = false;
        this.didNotificationsFetch = false;
    }

    componentWillReceiveProps(nextProps) {
        const { ownAccount, busCompany } = nextProps;

        if (
            this.isLoggedInWithRole(ownAccount, [UserRole.OPERATOR, UserRole.DISPATCHER]) &&
            !this.didNotificationsFetch
        ) {
            this.props.fetchAllCustomRepository(
                Entities.RECENT_OPERATOR_NOTIFICATIONS,
                'getNewNotificationsSinceLastLogin',
            );
            this.didNotificationsFetch = true;
        } else if (!this.isLoggedIn(ownAccount) && this.didNotificationsFetch) this.didNotificationsFetch = false;

        if (
            this.isLoggedInWithRole(ownAccount, [UserRole.OPERATOR, UserRole.DISPATCHER]) &&
            !this.didNewTasksFetch &&
            ownAccount.entity.previousLogin
        ) {
            const previousLogin = moment(ownAccount.entity.previousLogin).format('YYYY-MM-DD HH:mm:ss');
            nextProps.fetchNewTasksSinceLastLogin(ownAccount.entity.company, previousLogin);
            nextProps.fetchByCompanyId(Entities.BUS, busCompany.entity.id);
            this.didNewTasksFetch = true;
        } else if (!this.isLoggedIn(ownAccount) && this.didNewTasksFetch) this.didNewTasksFetch = false;
    }

    render() {
        const { t, ownAccount, busCompany, isError } = this.props;
        return (
            <nav className="navbar navbar-transparent">
                <div className="bf-navbar-wrapper">
                    <div className="bf-navbar-left-items">
                        {/* Home Image */}
                        {(isError || this.isLoggedIn(ownAccount)) && (
                            <IndexLink to="/">
                                <img
                                    src={`${logo}`}
                                    height="34"
                                    alt="busfinder-Logo"
                                    style={{ marginTop: '2px', paddingLeft: '14px', paddingRight: '10px' }}
                                />
                            </IndexLink>
                        )}

                        {/* Operator / Dispatcher Links */}
                        {this.isLoggedInWithRole(ownAccount, [UserRole.OPERATOR, UserRole.DISPATCHER]) &&
                            this.renderOperatorDispatcherLinks(
                                ownAccount,
                                busCompany.entity.partner,
                                busCompany.entity,
                                t,
                            )}

                        {/* Admin Links */}
                        {this.isLoggedInWithRole(ownAccount, [UserRole.ADMIN]) &&
                            this.renderLinks(this.getAdminLinks(t))}

                        {/* Super Admin Links */}
                        {this.isLoggedInWithRole(ownAccount, [UserRole.SUPER_ADMIN]) &&
                            this.renderLinks(this.getSuperAdminLinks(ownAccount, t))}

                        {this.isLoggedInWithRole(ownAccount, [UserRole.TRIP_OPERATOR]) &&
                            this.renderLinks(this.getTripOperatorLinks(t))}
                    </div>
                    {/* Notifications, Account, Logout */}
                    {this.isLoggedIn(ownAccount) && this.renderRightNavSection(ownAccount)}

                    {isError && !this.isLoggedIn(ownAccount) && (
                        <ul className="nav bf-navbar-custom navbar-right">
                            <li>
                                <Link to="/login" className="nav-link" activeClassName="active">
                                    <IconLabel icon="user" text={t('header_login')} />
                                </Link>
                            </li>
                        </ul>
                    )}
                </div>
            </nav>
        );
    }

    renderOperatorDispatcherLinks(ownAccount, isPartner, busCompany, t) {
        if (isPartner)
            return (
                <ul className="nav bf-navbar-custom">
                    <li>
                        <Link to="/administration" className="nav-link" activeClassName="active">
                            <IconLabel icon="briefcase" text={t('header_administration')} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/operating-tool" className="nav-link" activeClassName="active">
                            <IconLabel icon="calendar" text={t('header_operating_tool')} />
                        </Link>
                    </li>
                    <li>
                        <Link to="/task-administration" className="nav-link" activeClassName="active">
                            <IconLabel icon="list-alt" text={t('header_task_administration')} />
                        </Link>
                    </li>
                    {/* TODO: BUF-1397: The task exchange is hidden until we overhaul it */}
                    {/* <li> */}
                    {/*     <Link to="/task-exchange" className="nav-link" activeClassName="active"> */}
                    {/*         <span className="glyphicon glyphicon-list-alt" /> */}
                    {/*         &nbsp; */}
                    {/*         {t('header_task_exchange')} */}
                    {/*     </Link> */}
                    {/* </li> */}
                    <li>
                        <Link to="/offer-administration" className="nav-link" activeClassName="active">
                            <IconLabel icon="tags" text={t('header_offer_administration')} />
                        </Link>
                    </li>
                    {busCompany.integrationBusRequestFormEnabled && (
                        <li>
                            <Link to="/bus-requests-administration" className="nav-link" activeClassName="active">
                                <IconLabel icon="inbox" text={t('header_bus_request')} />
                            </Link>
                        </li>
                    )}
                    <li>
                        <Link to="/help" className="nav-link" activeClassName="active" title={t('help.help')}>
                            <IconLabel icon="info-sign" text={t('help.help')} collapse />
                        </Link>
                    </li>
                </ul>
            );

        return this.renderLinks(this.getNonEBAPartnerLinks(t));
    }

    renderRightNavSection(ownAccount) {
        const { newTasksSinceLastLogin, busCompany, t, newOperatorNotificationsSinceLastLogin } = this.props;

        if (newOperatorNotificationsSinceLastLogin.isFetching) return <CircularProgress />;

        return (
            <ul className="nav bf-navbar-custom navbar-right">
                {ownAccount.entity.fleet && <li>{this.getFleetInformation(busCompany.entity, ownAccount.entity)}</li>}
                {this.isLoggedInWithRole(ownAccount, [UserRole.OPERATOR]) && (
                    <li>
                        <VisibilityStatus
                            openModal={this.props.openModal}
                            busCompany={busCompany.entity}
                            t={t}
                            patch={this.props.patch}
                        />
                    </li>
                )}
                <li>
                    {this.isLoggedInWithRole(ownAccount, [UserRole.OPERATOR, UserRole.DISPATCHER]) &&
                        busCompany.entity.partner &&
                        newTasksSinceLastLogin.action.type === 'FETCH' && (
                            <OperatorNotificationsBadge
                                newTasksSinceLastLogin={newTasksSinceLastLogin}
                                newOperatorNotificationsSinceLastLogin={newOperatorNotificationsSinceLastLogin}
                                openModal={this.props.openModal}
                                t={t}
                            />
                        )}
                </li>
                <li>
                    <Link to="/account" className="nav-link" activeClassName="active">
                        <IconLabel icon="user" text={ownAccount.entity.contactData.firstName} />
                        {!ownAccount.entity.fleet && this.getCompanyInformation(busCompany)}
                    </Link>
                </li>

                <li>
                    <Logout />
                </li>
            </ul>
        );
    }

    renderLinks(links) {
        return (
            <ul className="nav bf-navbar-custom">
                {links.map((link, index) => (
                    <li key={index}>
                        <Link to={link.path} className="nav-link" activeClassName="active">
                            <span className={link.icon} />
                            &nbsp;
                            <span>{link.label}</span>
                        </Link>
                    </li>
                ))}
            </ul>
        );
    }

    getFleetInformation(busCompany, account) {
        const fleet = account.fleet;

        const companyMenuItems = fleet.companies
            .filter(company => company.active)
            .sort((a, b) => a.companyName.localeCompare(b.companyName))
            .map(company => {
                return <MenuItem key={company.id} value={company.id} primaryText={company.companyName} />;
            });

        return (
            <SelectField
                floatingLabelStyle={{ top: 28 }}
                menuStyle={{ marginTop: 5, width: '240px' }}
                underlineStyle={{ display: 'none' }}
                value={busCompany.id}
                onChange={(event, index, value) => {
                    asyncRequest({
                        method: 'PATCH',
                        endpoint: `${TOMCAT_URL}api/accounts/changeCompany?companyId=${value}`,
                    })
                        .then(response => {
                            if (response.status === HttpStatus.OK || response.status === HttpStatus.NO_CONTENT)
                                window.location.reload();
                            else console.log('Error changing company', response.status);
                        })
                        .catch(error => console.log('Error changing company', error));
                }}
                floatingLabelText={fleet.name}
                fullWidth={true}
                selectionRenderer={value => {
                    if (busCompany.logo)
                        return (
                            <div>
                                {busCompany.companyName}
                                &nbsp;
                                <img
                                    src={`${TOMCAT_URL}public/documents/${busCompany.logo.filename}`}
                                    width="42"
                                    height="18"
                                    alt={`${busCompany.companyName} Logo`}
                                />
                            </div>
                        );

                    return <div>{busCompany.companyName}</div>;
                }}>
                {companyMenuItems}
            </SelectField>
        );
    }

    getCompanyInformation(busCompany) {
        if (busCompany && busCompany.entity && busCompany.entity.companyName) {
            if (busCompany.entity.logo)
                return (
                    <span>
                        &nbsp;|&nbsp;
                        {busCompany.entity.companyName}
                        &nbsp;
                        <img
                            src={`${TOMCAT_URL}public/documents/${busCompany.entity.logo.filename}`}
                            width="42"
                            height="18"
                            alt={`${busCompany.entity.companyName} Logo`}
                        />
                    </span>
                );
            else
                return (
                    <span>
                        &nbsp;|&nbsp;
                        {busCompany.entity.companyName}
                    </span>
                );
        }

        return '';
    }

    getTripOperatorLinks(t) {
        return [
            {
                path: '/trips/administration',
                label: t('header_administration'),
                icon: 'glyphicon glyphicon-briefcase',
            },
            {
                path: `/trips/bookings?filter=${TripBookingFilter.FUTURE}`,
                label: t('booked_tasks.bookings'),
                icon: 'glyphicon glyphicon-flag',
            },
            {
                path: '/trips/calendar',
                label: t('calendar.calendar'),
                icon: 'glyphicon glyphicon-calendar',
            },
        ];
    }

    getAdminLinks(t) {
        return [
            {
                path: '/admin',
                label: t('header_administration'),
                icon: 'glyphicon glyphicon-briefcase',
            },
            {
                path: '/admin/trips',
                label: t('az_administration'),
                icon: 'glyphicon glyphicon-flag',
            },
            {
                path: '/admin/event-tickets',
                label: t('ticket.event_tickets'),
                icon: 'glyphicon glyphicon-tags',
            },
            {
                path: '/admin/bus-requests',
                label: t('bus_requests.title'),
                icon: 'glyphicon glyphicon-inbox',
            },
        ];
    }

    getSuperAdminLinks(ownAccount, t) {
        if (ownAccount.entity.email === 'evoadmin')
            return [
                {
                    path: '/admin',
                    label: t('header_administration'),
                    icon: 'glyphicon glyphicon-briefcase',
                },
            ];

        return this.getAdminLinks(t).concat([
            {
                path: '/superadmin',
                label: t('header_superadmin'),
                icon: 'glyphicon glyphicon-user',
            },
        ]);
    }

    getNonEBAPartnerLinks(t) {
        return [
            {
                path: '/event-tickets',
                label: t('ticket.event_tickets'),
                icon: 'glyphicon glyphicon-tags',
            },
        ];
    }

    isLoggedIn(account) {
        return account && !account.isFetching && account.entity;
    }

    isLoggedInWithRole(account, roles) {
        return this.isLoggedIn(account) && _.includes(roles, account.entity.role);
    }
}

const mapStateToProps = state => {
    return {
        newOperatorNotificationsSinceLastLogin: getEntities(state, Entities.RECENT_OPERATOR_NOTIFICATIONS),
    };
};

export default composeModalActions(
    withTranslation()(
        connect(mapStateToProps, {
            fetchAllCustomRepository,
        })(Header),
    ),
);
